import api from "lib/axios";

type ApiEnvelope<T> = {
  status: string;
  result: { data: T };
  message: string;
};

export type SupportContactSettings = {
  button_label_ar: string;
  button_label_en: string;
  button_subtitle_ar: string;
  button_subtitle_en: string;
  name_label_ar: string;
  name_label_en: string;
  name_placeholder_ar: string;
  name_placeholder_en: string;
  phone_label_ar: string;
  phone_label_en: string;
  phone_placeholder_ar: string;
  phone_placeholder_en: string;
  problem_label_ar: string;
  problem_label_en: string;
  problem_placeholder_ar: string;
  problem_placeholder_en: string;
  attachments_label_ar: string;
  attachments_label_en: string;
  attachments_button_ar: string;
  attachments_button_en: string;
  submit_label_ar: string;
  submit_label_en: string;
  sending_label_ar: string;
  sending_label_en: string;
};

export async function getSupportContactSettings(): Promise<SupportContactSettings> {
  const response = await api.get<ApiEnvelope<SupportContactSettings>>("/support/settings", {
    meta: { toast: false },
  });
  return response.data.result.data;
}
